<template>
	<div class="container__regrasdeotimizacao">
		<div>
			<div class="container__regrasdeotimizacao__titulo">
				<li class="fas fa-magic" />
				<label>{{ $t('optimizationRulesTitle') }}</label>
			</div>
			<label class="container__regrasdeotimizacao__subtitulo">{{
				$t('optimizationRulesSubtitle')
			}}</label>
		</div>
		<div class="container__regrasdeotimizacao__regras">
			<div class="container__regrasdeotimizacao__regras_item">
				<div style="display: flex">
					<label class="container__regrasdeotimizacao__regra__titulo">{{
						$t('operatingIncomeData')
					}}</label>
					<Tooltip
						style="margin-left: 0.5rem"
						:titulo="$t('incomingOperation')"
						:subtitulo="$t('optimizationRule')"
						:conteudo="$t('incomingOperationDescription')"
					/>
				</div>
				<Regra
					v-for="(rendimentoOperacional, index) in regraDeRendimentoOperacionalOrdenado"
					:key="index"
					:edicao-habilitada="rendimentoOperacional.edicaoHabilitada"
					:mostrar-opcao-para-editar-regra="!planejamentoJaGerouOrdensDeServico"
					@habilitarEdicao="habilitarEdicaoDaRegra(rendimentoOperacional)"
					@aplicarEdicao="desabilitarEdicaoDaRegra(rendimentoOperacional)"
					@excluirRegra="excluirRegra('rendimentoOperacional', rendimentoOperacional.id)"
				>
					<PrioridadeRegraDropdown
						:id="`${rendimentoOperacional.id}`"
						:ref="rendimentoOperacional.id"
						v-model="rendimentoOperacional.prioridade"
						semantic-class="mini"
						:options="opcoesDeOrdemRedimentoOperacional"
						tipo-da-regra="rendimentoOperacional"
						@repriorizarRegra="repriorizarRegra"
					/>
					{{ $t('for') }}
					<Dropdown
						v-model="rendimentoOperacional.coletor"
						:disabled="!rendimentoOperacional.edicaoHabilitada"
						:options="opcoesDeExecutoresPorRendimentoOperacional"
						:place-holder="$t('executorSelect')"
						width-auto
						@change="setarRendimentoMedioDoColetorQueFoiCalculado"
					/>,
					{{ $t('avarageIncoming') }}
					<NumericInput
						v-model="rendimentoOperacional.parcelasPorDia"
						:disabled="!rendimentoOperacional.edicaoHabilitada"
					/>
					{{ $t('plotsPerDay') }}
				</Regra>
				<label
					:class="[
						'container__regrasdeotimizacao__regra__adicionar',
						{ desabilitado: !habilitarAdicaoDeRegraDeRendimentoOperacional },
					]"
					@click="adicionarRegraDeRendimentoOperacional()"
					><i class="fas fa-plus" /> {{ $t('addIncomingOperation') }}</label
				>
			</div>

			<div class="container__regrasdeotimizacao__regras_item">
				<div style="display: flex">
					<label class="container__regrasdeotimizacao__regra__titulo">{{
						$t('rulesForServiceType')
					}}</label>
					<Tooltip
						style="margin-left: 0.5rem"
						:titulo="$t('rulesForServiceType')"
						:subtitulo="$t('optimizationRule')"
						:conteudo="$t('rulesForServiceTypeDescription')"
					/>
				</div>
				<Regra
					v-for="(tipoDeOrdemDeServico, index) in regraPorTipoDeOrdemDeServicoOrdenado"
					:key="index"
					:edicao-habilitada="tipoDeOrdemDeServico.edicaoHabilitada"
					:mostrar-opcao-para-editar-regra="!planejamentoJaGerouOrdensDeServico"
					@habilitarEdicao="habilitarEdicaoDaRegra(tipoDeOrdemDeServico)"
					@aplicarEdicao="desabilitarEdicaoDaRegra(tipoDeOrdemDeServico)"
					@excluirRegra="excluirRegra('tipoDeOrdemDeServico', tipoDeOrdemDeServico.id)"
				>
					<PrioridadeRegraDropdown
						:id="`${tipoDeOrdemDeServico.id}`"
						v-model="tipoDeOrdemDeServico.prioridade"
						semantic-class="mini"
						:options="opcoesDeOrdemPorTipoDeOrdemDeServico"
						tipo-da-regra="tipoDeOrdemDeServico"
						@repriorizarRegra="repriorizarRegra"
					/>
					{{ $t('for') }}
					<Dropdown
						v-model="tipoDeOrdemDeServico.tipoDeServico"
						:options="opcoesDeTiposDeOrdemDeServico"
						:disabled="!tipoDeOrdemDeServico.edicaoHabilitada"
						:place-holder="$t('selectServiceType')"
						width-auto
					/>,
					{{ $t('the') }}
					<Dropdown
						v-model="tipoDeOrdemDeServico.tipoDePrazo"
						:options="opcoesDePrazo"
						:disabled="!tipoDeOrdemDeServico.edicaoHabilitada"
						:place-holder="$t('selectDeadline')"
						width-auto
					/>
					{{ $t('is') }}
					<NumericInput
						v-model="tipoDeOrdemDeServico.quantidadeDeMeses"
						:disabled="!tipoDeOrdemDeServico.edicaoHabilitada"
					/>
					meses do(a)
					<Dropdown
						v-model="tipoDeOrdemDeServico.dataReferencia"
						:options="opcoesDeCriterioPorTipoDeOrdemDeServico(tipoDeOrdemDeServico.tipoDeServico)"
						:place-holder="$t('selectCriterion')"
						:disabled="!tipoDeOrdemDeServico.edicaoHabilitada"
						width-auto
					/>
				</Regra>
				<label
					:class="[
						'container__regrasdeotimizacao__regra__adicionar',
						{ desabilitado: !habilitarAdicaoDeRegraPorTipoDeOrdemDeServico },
					]"
					@click="adicionarRegraPorTipoDeOrdemDeServico"
					><i class="fas fa-plus" /> {{ $t('addRule') }}</label
				>
			</div>

			<div class="container__regrasdeotimizacao__regras_item">
				<label class="container__regrasdeotimizacao__regra__titulo">{{ $t('collectPlan') }}</label>
				<label class="container__regrasdeotimizacao__regra__subtitulo"
					>{{ $t('collectPlanCSV')
					}}<span @click="downloadExemploCSVPlanoDeColheita">{{
						$t('collectPlanCSVExample')
					}}</span></label
				>
				<div style="margin-top: 1rem">
					<label class="container__regrasdeotimizacao__regra__selecionar__arquivo"
						>{{ $t('collectPlan') }}:</label
					>
					<label
						style="text-decoration: underline; cursor: pointer; margin-left: 0.5rem"
						for="arquivo-plano-de-colheita"
						>{{ labelArquivoPlanoDeColheita }}</label
					>
				</div>
				<input
					id="arquivo-plano-de-colheita"
					type="file"
					style="display: none"
					@change="fazerUploadDoPlanoDeColheita($event)"
				/>
				<label
					v-show="mensagemDeErroCSV"
					class="container__regradeotimizacao__regra__mensagem_de_erro_arquivo"
					v-html="mensagemDeErroCSV"
				/>
				<Regra
					v-for="(planoDeColheita, index) in regraPorPlanoDeColheita"
					:key="index"
					:edicao-habilitada="planoDeColheita.edicaoHabilitada"
					:mostrar-opcao-para-editar-regra="!planejamentoJaGerouOrdensDeServico"
					@habilitarEdicao="habilitarEdicaoDaRegra(planoDeColheita)"
					@aplicarEdicao="desabilitarEdicaoDaRegra(planoDeColheita)"
					@excluirRegra="excluirRegra('planoDeColheita', planoDeColheita.id)"
				>
					<PrioridadeRegraDropdown
						:id="`${planoDeColheita.id}`"
						v-model="planoDeColheita.prioridade"
						semantic-class="mini"
						:options="opcoesDeOrdemPorPlanoDeColheita"
						tipo-da-regra="planoDeColheita"
						@repriorizarRegra="repriorizarRegra"
					/>
					{{ $t('forCollectPlan') }}
					<Dropdown
						v-model="planoDeColheita.tipoDePrazo"
						:options="opcoesDePrazo"
						:disabled="!planoDeColheita.edicaoHabilitada"
						:place-holder="$t('selectDeadline')"
						width-auto
					/>
					{{ $t('is') }}
					<NumericInput
						v-model="planoDeColheita.quantidadeDeMeses"
						:disabled="!planoDeColheita.edicaoHabilitada"
					/>
					{{ $t('monthsForCollectPlan') }}
				</Regra>
				<label
					:class="[
						'container__regrasdeotimizacao__regra__adicionar',
						{ desabilitado: !habilitarAdicaoDeRegraPorPlanoDeColheita },
					]"
					@click="adicionarRegraPorPlanoDeColheita"
					><i class="fas fa-plus" /> {{ $t('addRule') }}</label
				>
			</div>

			<div style="display: flex">
				<label
					class="container__regrasdeotimizacao__regra__titulo"
					style="margin-right: 0.5rem; font-weight: 700; color: var(--color-gray)"
					>{{ $t('otherRules') }}</label
				>
				<Tag
					:label="$t('comingSoon')"
					class-name="default"
				/>
			</div>
		</div>
		<div class="container__regrasdeotimizacao__botoes">
			<Button
				:label="$t('cancel')"
				color="trv-default"
				:disabled="salvandoRegraDeOtimizacao || validandoPlantiosParaPlanoDeColheita"
				outlined
				@click="cancelarRegraDeOtimizacao"
			/>
			<Button
				:label="$t('confirm')"
				color="trv-default"
				:loading="salvandoRegraDeOtimizacao"
				:disabled="validandoPlantiosParaPlanoDeColheita || desabilitarBotaoDeConfirmacao"
				@click="confirmarRegraDeOtimizacao"
			/>
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import download from 'downloadjs'
import Papa from 'papaparse'

import Button from '../../../../components/Button/Button'
import Tag from '../../../../components/Tag/Tag'
import Dropdown from '../../../../components/Dropdown/Dropdown'
import NumericInput from '../../../../components/NumericInput/NumericInput'
import PrioridadeRegraDropdown from './PrioridadeRegraDropdown/PrioridadeRegraDropdown'
import Tooltip from '../../../../components/Tooltip/Tooltip'
import Regra from './Regra/Regra'

import { recuperarExecutoresComMediaDeParcelasPorDia } from '../../../../services/requests/ExecutorRequests'
import { validarSeTodosOsPlantiosExistemParaPlanoDeColheita } from '../../../../services/requests/PlantioRequests'

import {
	tipoDeOrdemDeServicoComDescricao,
	tiposDeOrdensDeServico,
} from '../../../../constants/Mappings/TiposDeOrdensDeServico'

export default {
	components: {
		Button,
		PrioridadeRegraDropdown,
		Dropdown,
		NumericInput,
		Regra,
		Tooltip,
		Tag,
	},
	props: {
		planejamentoJaGerouOrdensDeServico: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			regrasDeOtimizacao: {
				rendimentoOperacional: [],
				tipoDeOrdemDeServico: [],
				planoDeColheita: [],
				outrasRegras: [
					{
						id: uuidv4(),
						ativo: false,
						tipoDeRegra: 'dias Úteis',
						valor: 0,
						edicaoHabilitada: false,
					},
					{
						id: uuidv4(),
						ativo: false,
						tipoDeRegra: 'dias de Folga',
						valor: 0,
						edicaoHabilitada: false,
					},
				],
			},
			executoresComMediaDeParcelasPorDia: [],
			mensagemDeErroCSV: '',
			cabecalhoDoCsvDePlanoDeColheita: ['fazenda', 'plantio', 'data_plantio', 'data_colheita'],
			plantiosParaPlanoDeColheita: [],
			nomeDoArquivoDePlanoDeColheita: '',
			opcoesDePrazo: [
				{ label: this.$t('prazoInicial'), value: 'PRAZOINICIAL' },
				{ label: this.$t('deadlines'), value: 'PRAZOFINAL' },
			],
			validandoPlantiosParaPlanoDeColheita: false,
			salvandoRegraDeOtimizacao: false,
		}
	},
	computed: {
		desabilitarBotaoDeConfirmacao() {
			return (
				!this.existeRegraPorRendimentoOperacional ||
				!this.existeRegraPorTipoDeOrdemDeServico ||
				this.existeRegraPorRendimentoOperacionalInvalida ||
				this.existeRegraPorTipoDeOrdemDeServicoInvalida
			)
		},
		existeRegraPorRendimentoOperacional() {
			return this.regrasDeOtimizacao.rendimentoOperacional.length > 0
		},
		existeRegraPorTipoDeOrdemDeServico() {
			return (
				this.regrasDeOtimizacao.tipoDeOrdemDeServico.length >= 1 ||
				this.regrasDeOtimizacao.planoDeColheita.length >= 1
			)
		},
		existeRegraPorRendimentoOperacionalInvalida() {
			return this.regrasDeOtimizacao.rendimentoOperacional.some(
				(regra) => regra.coletor === '' || regra.parcelasPorDia <= 0,
			)
		},
		existeRegraPorTipoDeOrdemDeServicoInvalida() {
			return this.regrasDeOtimizacao.tipoDeOrdemDeServico.some(
				(regra) => regra.dataReferencia === '' || regra.tipoDePrazo === '',
			)
		},
		regraDeRendimentoOperacionalOrdenado() {
			return this.regrasDeOtimizacao.rendimentoOperacional
				.slice()
				.sort((rendimento1, rendimento2) => rendimento1.prioridade - rendimento2.prioridade)
		},
		regraPorTipoDeOrdemDeServicoOrdenado() {
			return this.regrasDeOtimizacao.tipoDeOrdemDeServico
				.slice()
				.sort(
					(tipoDeOrdemDeServico1, tipoDeOrdemDeServico2) =>
						tipoDeOrdemDeServico1.prioridade - tipoDeOrdemDeServico2.prioridade,
				)
		},
		regraPorPlanoDeColheita() {
			return this.regrasDeOtimizacao.planoDeColheita
				.slice()
				.sort(
					(planoDeColheita1, planoDeColheita2) =>
						planoDeColheita1.prioridade - planoDeColheita2.prioridade,
				)
		},
		opcoesDeOrdemRedimentoOperacional() {
			return this.regrasDeOtimizacao.rendimentoOperacional.map((_, indice) => {
				return {
					label: `${indice + 1} º`,
					value: indice + 1,
				}
			})
		},
		opcoesDeOrdemPorTipoDeOrdemDeServico() {
			return this.regrasDeOtimizacao.tipoDeOrdemDeServico.map((_, indice) => {
				return {
					label: `${indice + 1} º`,
					value: indice + 1,
				}
			})
		},
		opcoesDeOrdemPorPlanoDeColheita() {
			return this.regrasDeOtimizacao.planoDeColheita.map((_, indice) => {
				return {
					label: `${indice + 1} º`,
					value: indice + 1,
				}
			})
		},
		opcoesDeExecutoresPorRendimentoOperacional() {
			const executoresJaSelecionados = this.regrasDeOtimizacao.rendimentoOperacional.map(
				(rendimentoOperacional) => rendimentoOperacional.coletor,
			)

			return this.executoresComMediaDeParcelasPorDia.map((executor) => {
				return {
					label: executor.executor,
					value: executor.id,
					hide: executoresJaSelecionados.includes(executor.id),
				}
			})
		},
		opcoesDeTiposDeOrdemDeServico() {
			const tiposDeOrdemDeServicoJaSelecionados = this.regrasDeOtimizacao.tipoDeOrdemDeServico.map(
				(tipoDeOrdemDeServico) => tipoDeOrdemDeServico.tipoDeServico,
			)

			const codigoOrdemDeServicoDeInstalacao = '001'
			const codigoOrdemDeServicoDeInventarioContinuo = '002'

			return tipoDeOrdemDeServicoComDescricao
				.filter(
					(tipoDeOrdemDeServico) =>
						tipoDeOrdemDeServico.codigo === codigoOrdemDeServicoDeInstalacao ||
						tipoDeOrdemDeServico.codigo === codigoOrdemDeServicoDeInventarioContinuo,
				)
				.map((tipoDeOrdemDeServico) => {
					return {
						label: tipoDeOrdemDeServico.descricao,
						value: tipoDeOrdemDeServico.codigo,
						hide: tiposDeOrdemDeServicoJaSelecionados.includes(tipoDeOrdemDeServico.codigo),
					}
				})
		},
		habilitarAdicaoDeRegraDeRendimentoOperacional() {
			return (
				this.regrasDeOtimizacao.rendimentoOperacional.length <
				this.executoresComMediaDeParcelasPorDia.length
			)
		},
		habilitarAdicaoDeRegraPorTipoDeOrdemDeServico() {
			return (
				this.regrasDeOtimizacao.tipoDeOrdemDeServico.length <
				this.opcoesDeTiposDeOrdemDeServico.length
			)
		},
		habilitarAdicaoDeRegraPorPlanoDeColheita() {
			const quantidadeDeRegrasDisponiveisParaPlanoDeColheita = 1
			return (
				this.regrasDeOtimizacao.planoDeColheita.length !=
				quantidadeDeRegrasDisponiveisParaPlanoDeColheita
			)
		},
		labelArquivoPlanoDeColheita() {
			if (this.validandoPlantiosParaPlanoDeColheita) return this.$t('validatingPlantation')
			return this.nomeDoArquivoDePlanoDeColheita
				? this.nomeDoArquivoDePlanoDeColheita
				: this.$t('selectFile')
		},
	},
	async created() {
		const { data: executoresComMediaDeParcelas } =
			await recuperarExecutoresComMediaDeParcelasPorDia()
		this.executoresComMediaDeParcelasPorDia = executoresComMediaDeParcelas
		this.validandoPlantiosParaPlanoDeColheita = false
	},
	methods: {
		setarRendimentoMedioDoColetorQueFoiCalculado(idExecutor) {
			const rendimentoOperacional = this.regrasDeOtimizacao.rendimentoOperacional.find(
				(rendimentoOperacional) => rendimentoOperacional.coletor === idExecutor,
			)

			const parcelasPorDiaDoExecutor = this.executoresComMediaDeParcelasPorDia.find(
				(executor) => executor.id === idExecutor,
			).parcelasPorDia

			rendimentoOperacional.parcelasPorDia = parcelasPorDiaDoExecutor
		},
		adicionarRegraDeRendimentoOperacional() {
			if (this.habilitarAdicaoDeRegraDeRendimentoOperacional) {
				const novaRegra = {
					id: uuidv4(),
					prioridade: this.regrasDeOtimizacao.rendimentoOperacional.length + 1,
					coletor: '',
					parcelasPorDia: 0,
					edicaoHabilitada: true,
				}

				this.regrasDeOtimizacao.rendimentoOperacional.push(novaRegra)
			}
		},
		adicionarRegraPorTipoDeOrdemDeServico() {
			if (this.habilitarAdicaoDeRegraPorTipoDeOrdemDeServico) {
				const novaRegra = {
					id: uuidv4(),
					prioridade: this.regrasDeOtimizacao.tipoDeOrdemDeServico.length + 1,
					tipoDeServico: '',
					tipoDePrazo: '',
					quantidadeDeMeses: 0,
					dataReferencia: '',
					edicaoHabilitada: true,
				}

				this.regrasDeOtimizacao.tipoDeOrdemDeServico.push(novaRegra)
			}
		},
		adicionarRegraPorPlanoDeColheita() {
			debugger
			if (this.habilitarAdicaoDeRegraPorPlanoDeColheita) {
				const novaRegra = {
					id: uuidv4(),
					prioridade: this.regrasDeOtimizacao.planoDeColheita.length + 1,
					tipoDePrazo: '',
					quantidadeDeMeses: 0,
					edicaoHabilitada: true,
				}

				this.regrasDeOtimizacao.planoDeColheita.push(novaRegra)
			}
		},
		habilitarEdicaoDaRegra(regra) {
			regra.edicaoHabilitada = true
		},
		desabilitarEdicaoDaRegra(regra) {
			regra.edicaoHabilitada = false
		},
		excluirRegra(tipoDeRegra, idDaRegra) {
			const indiceASerExcluido = this.regrasDeOtimizacao[tipoDeRegra]
				.map((regra) => regra.id)
				.indexOf(idDaRegra)

			const regraRemovida = this.regrasDeOtimizacao[tipoDeRegra].splice(indiceASerExcluido, 1)

			this.regrasDeOtimizacao[tipoDeRegra]
				.filter((regra) => regra.prioridade > regraRemovida[0].prioridade)
				.forEach((regra) => {
					regra.prioridade--
				})
		},
		repriorizarRegra(tipoDaRegra, prioridadeAntiga, prioridadeNova, idDaRegraComPrioridadeNova) {
			if (prioridadeNova > prioridadeAntiga) {
				this.regrasDeOtimizacao[tipoDaRegra]
					.filter(
						(regra) =>
							regra.prioridade > prioridadeAntiga &&
							regra.prioridade <= prioridadeNova &&
							regra.id !== idDaRegraComPrioridadeNova,
					)
					.forEach((regra) => {
						regra.prioridade--
					})
			} else {
				this.regrasDeOtimizacao[tipoDaRegra]
					.filter(
						(regra) =>
							regra.prioridade >= prioridadeNova &&
							regra.prioridade <= prioridadeAntiga &&
							regra.id !== idDaRegraComPrioridadeNova,
					)
					.forEach((regra) => {
						regra.prioridade++
					})
			}
		},
		downloadExemploCSVPlanoDeColheita() {
			const items = [
				['Fazenda Esperanca', 'P-01', '05/10/2015', '08/11/2023'],
				['Fazenda Esperanca 2', 'P-02', '01/06/2016', '05/12/2024'],
			]

			const csv = [this.cabecalhoDoCsvDePlanoDeColheita, ...items]
				.map((m) => m.join(';'))
				.join('\r\n')

			download(csv, 'base_plano_colheita.csv', 'text/csv')
		},
		fazerUploadDoPlanoDeColheita(event) {
			this.validandoPlantiosParaPlanoDeColheita = true
			const existeArquivo = event.target.files.length !== 0

			if (existeArquivo) {
				const arquivo = event.target.files[0]
				const extensaoDoArquivo = arquivo.name.split('.').pop()

				if (extensaoDoArquivo !== 'csv') {
					this.mensagemDeErroCSV = `${$t('arquivoDeTipoErrado')}: ${extensaoDoArquivo}`
					this.validandoPlantiosParaPlanoDeColheita = false
				}

				const vm = this

				Papa.parse(arquivo, {
					header: true,
					skipEmptyLines: true,
					complete: function ({ data: planosDeColheita }) {
						if (planosDeColheita.length !== 0) {
							const cabecalhoDoArquivo = Object.keys(planosDeColheita[0])

							if (!vm.cabecalhoDoCsvEstaValido(cabecalhoDoArquivo))
								vm.mensagemDeErroCSV = `O cabecalho do CSV não está válido, deve seguir o padrão do arquivo de exemplo`
							else {
								const dadosParaValidarPlanoDeColheita = planosDeColheita.map((planoDeColheita) => {
									const dataPlantio = planoDeColheita.data_plantio.split('/')
									const dataColheita = planoDeColheita.data_colheita.split('/')

									return {
										nomeFazenda: planoDeColheita.fazenda,
										plantio: planoDeColheita.plantio,
										dataDoPlantio: `${dataPlantio[1]}/${dataPlantio[0]}/${dataPlantio[2]}`,
										dataDeColheita: `${dataColheita[1]}/${dataColheita[0]}/${dataColheita[2]}`,
									}
								})

								validarSeTodosOsPlantiosExistemParaPlanoDeColheita(dadosParaValidarPlanoDeColheita)
									.then((response) => {
										vm.plantiosParaPlanoDeColheita = response.data
										vm.nomeDoArquivoDePlanoDeColheita = arquivo.name
										vm.mensagemDeErroCSV = ''
										vm.validandoPlantiosParaPlanoDeColheita = false
									})
									.catch((err) => {
										vm.validandoPlantiosParaPlanoDeColheita = false
										let mensagensDeErro = ''
										if (err.response.data.errors) {
											var mensagensPorAtributo = Object.values(err.response.data.errors)

											let mensagens = []
											mensagensPorAtributo.forEach((mensagensDeErro) => {
												mensagens.push(...mensagensDeErro)
											})

											mensagensDeErro = mensagens.map((mensagemDeErro) => `• ${mensagemDeErro}`)
										} else
											mensagensDeErro = err.response.data.map(
												(mensagemDeErro) => `• ${mensagemDeErro}`,
											)

										vm.mensagemDeErroCSV = mensagensDeErro.join('</br>')
										vm.removerArquivoDePlanoDeColheita()
									})
							}
						} else {
							vm.validandoPlantiosParaPlanoDeColheita = false
							vm.mensagemDeErroCSV = '• O arquivo está vazio'
						}
					},
				})
			}
		},
		removerArquivoDePlanoDeColheita() {
			this.plantiosParaPlanoDeColheita = []
			this.nomeDoArquivoDePlanoDeColheita = ''
			document.getElementById('arquivo-plano-de-colheita').value = ''
		},
		cabecalhoDoCsvEstaValido(cabecalho) {
			return this.cabecalhoDoCsvDePlanoDeColheita.every((cabecalhoValido) =>
				cabecalho.includes(cabecalhoValido),
			)
		},
		cancelarRegraDeOtimizacao() {
			this.$emit('fecharRegraDeOtimizacao')
		},
		confirmarRegraDeOtimizacao() {
			this.salvandoRegraDeOtimizacao = true
			this.$emit(
				'confirmarRegraDeOtimizacao',
				this.regrasDeOtimizacao,
				this.plantiosParaPlanoDeColheita,
			)
		},
		limparRegrasDeOtimizacao() {
			this.regrasDeOtimizacao = {
				rendimentoOperacional: [],
				tipoDeOrdemDeServico: [],
				planoDeColheita: [],
				outrasRegras: [
					{
						id: uuidv4(),
						ativo: false,
						tipoDeRegra: 'dias Úteis',
						valor: 0,
						edicaoHabilitada: false,
					},
					{
						id: uuidv4(),
						ativo: false,
						tipoDeRegra: 'dias de Folga',
						valor: 0,
						edicaoHabilitada: false,
					},
				],
			}
		},
		habilitarBotoesAposRequisicao() {
			this.salvandoRegraDeOtimizacao = false
		},
		opcoesDeCriterioPorTipoDeOrdemDeServico(tipoDeServico) {
			var opcoesDeCriterio = [{ label: this.$t('plantationDate'), value: 'DATADOPLANTIO' }]

			if (tipoDeServico === tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO)
				this.selecionarValorPadraoParaInventarioDeInstalacao()
			else if (tipoDeServico === tiposDeOrdensDeServico.INVENTARIO_CONTINUO)
				opcoesDeCriterio.push({
					label: this.$t('lastMeasurementDate'),
					value: 'DATADAULTIMAMEDICAO',
				})

			return opcoesDeCriterio
		},
		selecionarValorPadraoParaInventarioDeInstalacao() {
			var regraDeOrdemDeServicoDeInstalacao = this.regrasDeOtimizacao.tipoDeOrdemDeServico.find(
				(tipoDeOrdemDeServico) =>
					tipoDeOrdemDeServico.tipoDeServico === tiposDeOrdensDeServico.INVENTARIO_DE_INSTALACAO,
			)

			regraDeOrdemDeServicoDeInstalacao.dataReferencia = 'DATADOPLANTIO'
		},
	},
}
</script>

<style scoped>
.container__regrasdeotimizacao {
	background-color: white;
	padding: 1.5rem 2rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	font-size: 0.875rem;
	user-select: none;
	height: 100%;
	width: 100%;
}

.container__regrasdeotimizacao__titulo {
	font-size: 1.5rem;
	font-weight: 700;
	line-height: normal;
	display: flex;
	-ms-flex-align: start;
	color: rgb(var(--color-primary));
	align-items: center;
}

.container__regrasdeotimizacao__subtitulo {
	color: var(--color-gray-dark);
	font-weight: 400;
}

.container__regrasdeotimizacao__titulo > li {
	height: 32px;
	width: 32px;
	font-size: 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
}

.container__regrasdeotimizacao__regras {
	height: 100%;
	overflow-y: auto;
	margin-top: 1.5rem;
	margin-bottom: 1.5rem;
	padding-right: 1rem;
}

.container__regrasdeotimizacao__regras_item {
	margin-top: 0.75rem;
	margin-bottom: 0.75rem;
	display: flex;
	flex-direction: column;
	color: rgb(var(--color-primary));
}

.container__regrasdeotimizacao__regra__titulo {
	font-weight: 700;
}

.container__regrasdeotimizacao__regra__subtitulo {
	font-size: 0.875rem;
	color: var(--color-gray-dark);
}

.container__regrasdeotimizacao__regra__subtitulo > span {
	text-decoration: underline;
	color: rgb(var(--color-primary));
	cursor: pointer;
}

.container__regrasdeotimizacao__regra__selecionar__arquivo {
	font-size: 0.875rem;
	font-weight: 700;
	color: var(--color-gray-dark);
	margin-top: 1rem;
}

.container__regrasdeotimizacao__regra__selecionar__arquivo > label {
	text-decoration: underline;
	font-weight: 400;
	color: rgb(var(--color-primary));
	cursor: pointer;
}

.container__regradeotimizacao__regra__mensagem_de_erro_arquivo {
	color: var(--color-error-background);
	font-size: 0.875rem;
}

.container__regrasdeotimizacao__regra__adicionar {
	cursor: pointer;
	align-self: flex-end;
	margin-top: 0.5rem;
}

.container__regrasdeotimizacao__regra__adicionar.desabilitado {
	cursor: unset;
	color: var(--color-gray);
}

.container__regrasdeotimizacao__regra__adicionar:hover {
	font-weight: 600;
	text-decoration: underline;
}

.container__regrasdeotimizacao__regra__adicionar.desabilitado:hover {
	font-weight: unset;
	text-decoration: unset;
}

.container__regrasdeotimizacao__botoes {
	display: flex;
	gap: 1rem;
}

@media screen and (min-width: 992px) {
	.container__regrasdeotimizacao {
		height: auto;
		width: auto;
		max-height: 90vh;
	}
}
</style>
